import { toast as toastMessage } from "react-toastify";
type Types = "success" | "error" | "info" | "warning";

export const toast = (type: Types, content: string) => {
  // message.config({
  //   getContainer: () => {
  //     const container = document.createElement("div");
  //     container.className = "custom-toast-message";
  //     document.body.appendChild(container);
  //     return container;
  //   },
  //   maxCount: 1,
  // });

  switch (type) {
    case "success":
      toastMessage.success(content);
      // message.success(content);
      break;
    case "error":
      toastMessage.error(content);
      // message.error(content);
      break;
    case "info":
      toastMessage.info(content);
      // message.info(content);
      break;
    case "warning":
      toastMessage.warning(content);
      // message.warning(content);
      break;
    default:
      toastMessage.info(content);
    // message.info(content);
  }
};
